export { BinaryColumnComponent } from './binary-column.component';
